import { render, staticRenderFns } from "./DeclarationList.vue?vue&type=template&id=0c422b46&"
import script from "./DeclarationList.vue?vue&type=script&lang=js&"
export * from "./DeclarationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports